export default __webpack_public_path__ + "static/media/filter_user_light.c8b59d23.svg";